import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { BsX } from 'react-icons/bs';
import './ExternalLink.scss';
import { BsChevronDown } from 'react-icons/bs';
import { ReactComponent as CompassIcon } from '../../../assets/images/graphics/icn_compass.svg';
import { Link } from 'react-router-dom';

const ExternalLink = ({ index, text, link, isExternal, isInline }) => {
  const [expanded, setExpanded] = useState(false);
  const activeKey = useSelector(state => state.data.activeSlideKey);

  useEffect(() => {
    if (index !== activeKey) {
      setExpanded(false);
    }
  }, [activeKey, index]);

  if(isInline){
    return (
      <div className={`lightBg externalLink expanded inline`}>
        <div className="content">
          {isExternal ? 
            <a className="link-text" href={link} target="_blank" rel="noopener noreferrer" tabIndex={0}>
              {text}
              <BsChevronDown className="next" width="20px" height="20px" fill="white" />
            </a>
            :
            <Link className="link-text" to={link} tabIndex={0}>
              {text}
              <BsChevronDown className="next" width="20px" height="20px" fill="white" />
            </Link>
          }
        </div>
      </div>
    );
  } else {
    return (
      <div
        className={`darkBg externalLink ${expanded ? 'expanded' : ''}`}
        onClick={() => setExpanded(!expanded)}
      >
        <div className="checkmark">
          <CompassIcon />
        </div>
        <div className="content">
          <b className="banner-content" tabIndex={0}>{text}</b>
          {isExternal ? 
            <a className="go-btn" href={link} target="_blank" rel="noopener noreferrer" tabIndex={0}>
              Go
            </a>
            :
            <Link className="go-btn" to={link} tabIndex={0}>
              Go
            </Link>
          }
        </div>
      </div>
    );
  }
};

export default ExternalLink;
